import { graphql, useStaticQuery } from 'gatsby';
import { useMemo } from 'react';
import { MenuItem } from '../../../models/MenuItem';
import { sortMenuItems } from '../../../shared/sortMenuItems';
import { processLink } from '../../../shared/processLink';
import { useLayoutContext } from '../../../providers/LayoutProvider';

export const useMainMenuData = () => {
    const { isPolicy } = useLayoutContext();

    const sitesMenuData = useStaticQuery(graphql`
        query {
            allMenuItems(
                filter: {
                    menu_name: {
                        in: ["main", "public-policy", "footer-spectrum-site"]
                    }
                }
            ) {
                nodes {
                    title
                    menu_name
                    id
                    url
                    weight
                    childrenMenuItems {
                        id
                        title
                        weight
                        menu_name
                        url
                    }
                }
            }
        }
    `);

    const itemsSrc = useMemo(
        () => [...sitesMenuData.allMenuItems.nodes].sort(sortMenuItems),
        [sitesMenuData.allMenuItems.nodes]
    );

    const parentItems: MenuItem[] = useMemo(() => {
        const items = itemsSrc
            .filter((item) => item.childrenMenuItems.length)
            .sort(sortMenuItems)
            .map((item) => ({ ...item }));

        if (isPolicy) {
            const policy = items.find((item) =>
                item.title.toLowerCase().includes(`policy`)
            );
            if (policy) {
                policy.childrenMenuItems = itemsSrc
                    .filter((item) => item.menu_name === `public-policy`)
                    .map((node): MenuItem => ({
                        url: node.url,
                        title: node.title,
                        id: node.id,
                        weight: node.weight,
                        enabled: node.enabled,
                        menu_name: `policy`,
                        childrenMenuItems: [],
                    }));
            }
        }

        return items;
    }, [itemsSrc, isPolicy]);

    const footerSitesItems: MenuItem[] = useMemo(() => {
        return itemsSrc.filter(
            (item) => item.menu_name === `footer-spectrum-site`
        );
    }, [itemsSrc]);

    const policyNavItems: MenuItem[] = useMemo(() => {
        return itemsSrc
            .filter((item) => item.menu_name === `public-policy`)
            .map((item) => ({
                ...item,
                url: processLink(item.url, true),
            }));
    }, [itemsSrc]);

    return { parentItems, footerSitesItems, policyNavItems };
};
